import { Carousel } from "../classes/Carousel";

export class HomePageAppsSliderComponent {
  init() {
    const slider = new Carousel(
      document.querySelector('#slider .slider__inner'),
      document.querySelectorAll('#slider .slider__inner .slider__inner__slide'),
      7,
      2000
    );

    slider.init();

    document.querySelectorAll('#slider .slider__inner .slider__inner__slide').forEach(slide => {
      slide.addEventListener('click', () => {
        const lang = document.documentElement.lang;
        location.href = `/${lang}/${slide.getAttribute('data-id')}`;
      });
    })
  }
}
